import { createI18n } from 'vue-i18n'

import en from './locales/en'
import sl from './locales/sl'
import fr from './locales/fr'
import de from './locales/de'
import hr from './locales/hr'

export type AvailableLocales = 'sl' | 'en' | 'fr' | 'de' | 'hr'

// The language switch's entries, each named in its own language (as the legacy portal did).
export const LOCALES: { code: AvailableLocales, name: string }[] = [
    { code: 'sl', name: 'Slovenščina' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'de', name: 'Deutsch' },
    { code: 'hr', name: 'Hrvatski' },
]

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           'sl',
    fallbackLocale:   'en',
    messages:         { sl, en, fr, de, hr },
    availableLocales: ['sl', 'en', 'fr', 'de', 'hr'],
})

export default i18n
